/**
 * Shared Fluent UI toggle grid for rune variant selection.
 * Used by both Inspector v2 StageControlsService and React demo pages.
 *
 * @deprecated Use VariantSelector with mode="multi" for new code.
 * This component is kept for backward compatibility and delegates to VariantSelector.
 */

import type { FC } from "react";
import type { RuneVariant } from "../../managers/scene/RuneManager.js";
import { RUNE_VARIANT_OPTIONS } from "../variants/runeVariantOptions.js";
import { VariantSelector } from "./VariantSelector.js";

export interface VariantToggleGridProps {
  /** All available variants to display */
  variants: readonly RuneVariant[];
  /** Currently selected variants */
  selected: RuneVariant[];
  /** Called when a variant is toggled */
  onToggle: (variant: RuneVariant) => void;
  /** Optional label (defaults to "Variants") */
  label?: string;
}

/**
 * Grid of toggle buttons for selecting rune variants.
 * Displays count of selected variants in the label.
 *
 * @deprecated Use VariantSelector with mode="multi" directly for new code.
 */
export const VariantToggleGrid: FC<VariantToggleGridProps> = ({
  variants,
  selected,
  onToggle,
  label,
}) => {
  // Filter options to only include the variants passed in
  // This maintains backward compatibility where consumers could pass a subset
  const filteredOptions = RUNE_VARIANT_OPTIONS.filter((opt) =>
    variants.includes(opt.value),
  );

  return (
    <VariantSelector
      label={label}
      mode="multi"
      onToggle={onToggle}
      options={filteredOptions}
      selected={selected}
    />
  );
};
